var x = /* @__PURE__ */ ((s) => (s.xs = "xs", s.s = "s", s.m = "m", s.l = "l", s.xl = "xl", s.None = "", s))(x || {});
export {
  x as S
};
